import { Header, Popover, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import { Box } from '@cloudscape-design/components';
import { DripEmailBasic } from '../common/types';
import { formatDateStringWithTime } from '../common/formatting/dateFormat';

export type DripEmailStatusProps = {
  item: DripEmailBasic;
};

export function DripEmailStatus(props: DripEmailStatusProps) {
  const { item } = props;
  let icon = (
    // 'error' | 'warning' | 'success' | 'info' | 'stopped' | 'pending' | 'in-progress' | 'loading'
    <StatusIndicator type="pending">
      {/* scheduled */}
      Scheduled
    </StatusIndicator>
  );
  let description = (
    <SpaceBetween direction="vertical" size="xxs">
      {item.scheduled_at ? formatDateStringWithTime(item.scheduled_at) : '-'}
    </SpaceBetween>
  );
  if (item.status === 'sent') {
    icon = <StatusIndicator type="in-progress">Sent</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.sent_at ? formatDateStringWithTime(item.sent_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'opened') {
    icon = <StatusIndicator type="info">Opened</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.opened_at ? formatDateStringWithTime(item.opened_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'failed') {
    icon = <StatusIndicator type="error">Failed</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.failed_at ? formatDateStringWithTime(item.failed_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'cancelled') {
    icon = <StatusIndicator type="stopped">Cancelled</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.cancelled_at ? formatDateStringWithTime(item.cancelled_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'clicked') {
    icon = <StatusIndicator type="success">Clicked</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.clicked_at ? formatDateStringWithTime(item.clicked_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'bounced') {
    icon = <StatusIndicator type="error">Bounced</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.bounced_at ? formatDateStringWithTime(item.bounced_at) : '-'}
      </SpaceBetween>
    );
  } else if (item.status === 'unsubscribed') {
    icon = <StatusIndicator type="warning">Unsubscribed</StatusIndicator>;
    description = (
      <SpaceBetween direction="vertical" size="xxs">
        {item.unsubscribed_at ? formatDateStringWithTime(item.unsubscribed_at) : '-'}
      </SpaceBetween>
    );
  }

  return (
    <Header variant="h3" description={description}>
      <Popover
        size="large"
        triggerType="text"
        content={
          <SpaceBetween direction="vertical" size="xxs">
            {item.unsubscribed_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.unsubscribed_at ? formatDateStringWithTime(item.unsubscribed_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="warning">Unsubscribed</StatusIndicator>
              </Header>
            )}
            {item.clicked_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.clicked_at ? formatDateStringWithTime(item.clicked_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="success">Clicked</StatusIndicator>
              </Header>
            )}
            {item.opened_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.opened_at ? formatDateStringWithTime(item.opened_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="info">Opened</StatusIndicator>
              </Header>
            )}
            {item.bounced_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.bounced_at ? formatDateStringWithTime(item.bounced_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="error">Bounced</StatusIndicator>
              </Header>
            )}
            {item.sent_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.sent_at ? formatDateStringWithTime(item.sent_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="in-progress">Sent</StatusIndicator>
              </Header>
            )}
            {item.status === 'failed' && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.failed_at ? formatDateStringWithTime(item.failed_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="error">Failed</StatusIndicator>
              </Header>
            )}
            {item.status === 'cancelled' && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.cancelled_at ? formatDateStringWithTime(item.cancelled_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="stopped">Cancelled</StatusIndicator>
              </Header>
            )}
            {item.scheduled_at && (
              <Header
                variant="h3"
                description={
                  <SpaceBetween direction="vertical" size="xxs">
                    {item.scheduled_at ? formatDateStringWithTime(item.scheduled_at) : '-'}
                  </SpaceBetween>
                }
              >
                <StatusIndicator type="pending">Scheduled</StatusIndicator>
              </Header>
            )}
          </SpaceBetween>
        }
      >
        {icon}
      </Popover>
    </Header>
  );
}
